module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/woman_524a32.png";